import { useContext } from 'react';
import { ClockContext, ClockContextType } from '../contexts/clock_context';

const useClock = () => {
    return useContext(ClockContext) as ClockContextType;
};

export default useClock;
